import { Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { has } from 'lodash'
import tippy, { Instance } from 'tippy.js'

@Directive({
    selector: '[tippy]',
})
export class TippyDirective implements OnInit, OnChanges {
    @Input() public tippyOptions: Record<string, unknown>

    tippyInstance: Instance

    constructor(private el: ElementRef) {
        this.el = el
    }

    public ngOnInit() {
        this.tippyInstance = tippy(this.el.nativeElement) as unknown as Instance
        this.setProps()
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.tippyInstance && has(changes, 'tippyOptions')) this.setProps()
    }

    setProps() {
        this.tippyInstance.setProps(this.tippyOptions || {})
        if (!this.tippyOptions) this.tippyInstance.disable()
        else this.tippyInstance.enable()
    }
}
